import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiUtils } from 'src/app/util/ui-utils';
import { Option } from 'src/app/models/option';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-option-add-edit-modal',
  templateUrl: './option-add-edit-modal.component.html',
  styleUrls: ['./option-add-edit-modal.component.scss'],
})
export class OptionAddEditModalComponent implements OnInit {

  @Input() option: Option;

  optionBeforeChanges: Option;
  mode: 'adding'|'editing' = 'editing'

  constructor(
    private modalController: ModalController,
    private uiUtils: UiUtils,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    if (!this.option) {
      this.option = new Option();
      this.mode = 'adding'
    }

    this.optionBeforeChanges = {...this.option};

    this.modalController.getTop().then((ionModal: HTMLIonModalElement) => {
      ionModal.cssClass = 'custom-modal';
    })
  }

  dismissSelfWithData() {
    const formValidation = this.getFormValidation();
    if (!formValidation.isValid) return this.uiUtils.showConfirmAlert(this.translateService.instant('generic.invalidField'), formValidation.errorMsg, this.translateService.instant('generic.accept'));

    if (!this.option.price) this.option.price = new Option().price;

    this.modalController.dismiss({ 'option': this.option });
  }

  dismissSelfWithoutData() {
    if (!this.hasChanged()) return this.modalController.dismiss();

    this.uiUtils.showAlert('', this.translateService.instant('generic.exitWithoutSave'), '', [
      { text: this.translateService.instant('generic.save'), handler: () => this.dismissSelfWithData() },
      { text: this.translateService.instant('generic.dontSave'), handler: () => this.modalController.dismiss() },
      { text: this.translateService.instant('generic.cancel') }
    ]);
  }

  private hasChanged() {
    if (this.optionBeforeChanges.name != this.option.name) return true;
    if (this.optionBeforeChanges.price != this.option.price) return true;

    return false;
  }

  private getFormValidation() {
    let isValid = true;
    let errorMsg: string;

    if (!this.option.name ) errorMsg = this.translateService.instant('component.option_add_edit_modal.message.nameRequired');
    if (this.option.price && this.option.price <= 0) errorMsg = this.translateService.instant('component.option_add_edit_modal.message.priceValue');

    isValid = errorMsg ? false : true;
    return {isValid, errorMsg};
  }

}
